import { FC, ReactNode } from 'react'
import { GridHeader, GridItems } from '@/ui/components'

const Home: FC = (): ReactNode => {
    return (
        <div className='h-full'>
            <section className='bg-[#262626] border border-[#424242] p-2 pt-0.5 pb-0 rounded-md w-full'>
                <GridHeader />
                <GridItems />
            </section>
        </div>
    )
}

export default Home
